import React,{Component} from 'react';
import Status from './Status';
import Attachments from './Attachments';
import Overview from './Overview'
import ChatBox from './chatbox'
import Link from './Link'
import cookie from '../../helper/cookie'
import Relay from 'react-relay';

class Userdashboardpage extends Component{
  constructor(props)
  {
    super(props);

    var date = new Date(this.props.viewer.startDate);
    date = String(date).split(" ")[2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
    
    var overviewData = {
      stat: this.props.viewer.status,
      NumberOfResp: this.props.viewer.numberOfRespondents,
      dateOfStart: date,
      ProjEng: this.props.viewer.frontfacer,
      image: "http://dndw32r4edmw5.cloudfront.net/avatar/Male.png"
    }

    var surveylink;
    if (this.props.viewer.linkToReview == null){
      surveylink = "Not Available"
    }
    else {
      surveylink = this.props.viewer.linkToReview
    }
    var reportlink;
    if (this.props.viewer.linkToReport == null){
      reportlink = "Not Available"
    }
    else {
      reportlink = this.props.viewer.linkToReport
    }
    var linkData = {
      survey: surveylink,
      report: reportlink
    }

    var teamData = [];
    this.props.viewer.users.map((object, index) => {
      teamData.push({
        customeremail: object.email,
        customerimg: object.picture
      });
    });

    var chatboxData = {
      projectMembers: teamData,
      agent: {
        agentImage: "http://dndw32r4edmw5.cloudfront.net/avatar/Male.png",
        agentName: this.props.viewer.frontfacer
      },
      customerName: this.props.viewer.customer.name,
      customerId: this.props.viewer.customer.pid,
      pid: this.props.viewer.pid
    }

    this.state={
      title : this.props.viewer.name,
      stat : this.props.viewer.step,
      overviewData: overviewData,
      linkData: linkData,
      chatboxData: chatboxData
    }

  }
  render()
  {
    if (cookie.get('access_token') != null) {
    return(
        <div style={{backgroundColor:"#fafafa"}}>
          <div style={{marginTop:"0px"}}>
            <Status stat={this.state.stat}/>
          </div>

          <hr style={{marginTop:"0px"}}/>

          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-4">
                <div className="row">
                  <ChatBox isAgentSide="false" data={this.state.chatboxData} />
                </div>
                
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-5">
              <div className="row" style={{marginTop:-20}}>
                  <h1>{this.state.title}</h1>
                  <p className="text-muted"><small>Every Surveymate project comes with our 100% guarantee.</small></p>
              </div>
              <div className="row">
                  <Overview data={this.state.overviewData}/>
              </div>
              <div className="row">
                  <Link data={this.state.linkData}/>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>

    );
    }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

export default Relay.createContainer(Userdashboardpage, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Conversation {
        pid
        name
        linkToReview
        linkToReport
        step
        startDate
        status
        customer {
          name
          picture
          pid
        }
        users{
          email
          picture
        }
        numberOfRespondents
        frontfacer
      }
    `
  }
});




/** WEBPACK FOOTER **
 ** ./src/views/clientDashboard/index.js
 **/